import React from 'react';
import PropTypes from 'prop-types';

export const IconPlusWallet = ({ className }) => (
  <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="12" fill="url(#icn-plus-wallet-1)" />
    <path
      d="M11.25 23.0625H18.3656C18.6762 23.0625 18.9281 22.8109 18.9281 22.5C18.9281 22.1891 18.6762 21.9375 18.3656 21.9375H11.25C10.0094 21.9375 9 20.9284 9 19.6875V10.8281C9 10.1305 9.56772 9.5625 10.2656 9.5625H19.125C19.4351 9.5625 19.6875 9.81464 19.6875 10.125V10.9688H10.8281C10.5175 10.9688 10.2656 11.2203 10.2656 11.5312C10.2656 11.8422 10.5175 12.0938 10.8281 12.0938H21.9375C22.2476 12.0938 22.5 12.3459 22.5 12.6562V14.7546H19.1363C18.537 14.7546 17.9695 14.9875 17.5312 15.4177C17.1079 15.8489 16.875 16.4163 16.875 17.0156C16.875 18.2626 17.8893 19.2772 19.1363 19.2772H19.9462C20.2569 19.2772 20.5087 19.0256 20.5087 18.7147C20.5087 18.4037 20.2569 18.1522 19.9462 18.1522H19.1363C18.5098 18.1522 18 17.6424 18 17.0156C18 16.713 18.1187 16.4251 18.3263 16.2136C18.5457 15.9983 18.8333 15.8796 19.1363 15.8796H22.5V17.8033C22.5 18.1143 22.7519 18.3658 23.0625 18.3658C23.3731 18.3658 23.625 18.1143 23.625 17.8033V12.6562C23.625 11.7257 22.868 10.9688 21.9375 10.9688H20.8125V10.125C20.8125 9.19446 20.0555 8.4375 19.125 8.4375H10.2656C8.94754 8.4375 7.875 9.50977 7.875 10.8281V19.6875C7.875 21.5486 9.38892 23.0625 11.25 23.0625Z"
      fill="white"
    />
    <path
      d="M23.562 20.8126H22.4996V19.7502C22.4996 19.4393 22.2477 19.1877 21.9371 19.1877C21.6265 19.1877 21.3746 19.4393 21.3746 19.7502V20.8126H20.3125C20.0019 20.8126 19.75 21.0642 19.75 21.3751C19.75 21.686 20.0019 21.9376 20.3125 21.9376H21.3746V23C21.3746 23.3109 21.6265 23.5625 21.9371 23.5625C22.2477 23.5625 22.4996 23.3109 22.4996 23V21.9376H23.562C23.8726 21.9376 24.1245 21.686 24.1245 21.3751C24.1245 21.0642 23.8726 20.8126 23.562 20.8126Z"
      fill="white"
    />
  </svg>

);

IconPlusWallet.propTypes = {
  className: PropTypes.string,
};

IconPlusWallet.defaultProps = {
  className: null,
};
